import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { CONFIG, ExceptionService, MessageService, SpinnerService, HttpWrapper } from '../../core';
import { Eventos } from '../shared';
import { environment } from '../../../environments/environment';
let eventsUrl = CONFIG.baseUrls.events;

@Injectable()
export class EventService {
  onDbReset = this.messageService.state;

  constructor(
    private http: HttpWrapper,
    private exceptionService: ExceptionService,
    private messageService: MessageService,
    private spinnerService: SpinnerService
  ) {
   // this.messageService.state.subscribe(state => this.getEvents());
  }

  addEvent(event: Eventos) {
    let body = JSON.stringify(event);
    this.spinnerService.show();
    return <Observable<Eventos>>this.http
      .post(`${eventsUrl}`, body)
      .map(res => res.json().data)
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => this.spinnerService.hide());
  }

  deleteEvent(event: Eventos) {
    this.spinnerService.show();
    return <Observable<Eventos>>this.http
      .delete(`${eventsUrl}/${event.id}`)
      .map(res => this.extractData<Eventos>(res))
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => this.spinnerService.hide());
  }

  getEvents(contentId:number) {
    //this.spinnerService.show();
    //console.log('contentId', contentId);
    return <Observable<Eventos[]>>this.http
      .get(`${eventsUrl}/Eventos?contentId=${contentId}`)
      .map(res => this.extractData<Eventos[]>(res))
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => {
        // () => this.spinnerService.hide()
      });
  }

  getEventsHomepage() {
    //this.spinnerService.show();
    //console.log('contentId', contentId);
    return <Observable<Eventos[]>>this.http
      .get(`${eventsUrl}/GetEventsForDashboard`)
      .map(res => this.extractData<Eventos[]>(res))
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => {
        // () => this.spinnerService.hide()
      });
  }

  getEventt(id: number) {
    this.spinnerService.show();
    return <Observable<Eventos>>this.http
      .get(`${eventsUrl}/${id}`)
      .map(res => this.extractData<Eventos>(res))
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => this.spinnerService.hide());
  }

  updateEvent(event: Eventos) {
    let body = JSON.stringify(document);
    this.spinnerService.show();

    return <Observable<Eventos>>this.http
      .put(`${eventsUrl}/${event.id}`, body)
      .map(res => this.extractData<Eventos>(res))
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => this.spinnerService.hide());
  }

  private extractData<T>(res: Response) {
    if (res.status < 200 || res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }
    let body = res.json ? res.json() : null;
    return <T>(body || {});
  }
}



// WEBPACK FOOTER //
// ./src/app/events/shared/event.service.ts